/** Dojo's `_getYears` bounds: currentYear + 2 down to 2015 (EmployeeWorkAgreementsHours.js:415-416). */
export const MIN_HOURS_YEAR = 2015;
export const HOURS_YEARS_AHEAD = 2;

/**
 * The columns the footer summed in Dojo (`EmployeeWorkAgreementsHours.js:314`).
 * These are DataGrid field ids, which for every one of them equals the data key.
 */
export const SUMMARY_FIELDS = [
  'hoursContract',
  'hoursExtra',
  'hoursCompLeave',
  'empPaidHours',
  'hoursDeployed',
  'hoursIll',
  'hoursHolidayTotal',
  'hoursPlbUsedDirect',
  'hoursBalance',
  'empLeaveHours',
  'hoursPlbRights'
] as const;

/** Persisted per user via the preferences saga; see useHoursColumnVisibility. */
export const COLUMN_VISIBILITY_PREFERENCE_KEY = 'employmentHoursVisibleColumns';

/** Detail-panel table order and the tables the user removed; see useHoursDetailLayout. */
export const DETAIL_LAYOUT_PREFERENCE_KEY = 'employmentHoursDetailLayout';

/** Org preference that turns on the plus/minus presentation of balance columns. */
export const PLUS_MINUS_PRESENTATION_MODE =
  'SHOW_MORE_HOURS_WITH_PLUS_SIGN_AND_MINUS_HOURS_WITH_MINUS_SIGN';

export const HOURS_DECIMALS = 2;
